<template>
    <form v-on:submit.prevent="updatePassword" action="">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="form-group" :class="{'form-group--error': $v.profile.current_password.$error}">
                    <input
                            :placeholder="'OLD PASSWORD' | trans"
                            type="password"
                            v-model="profile.current_password"
                            class="form-control"
                            id="current_password"
                            :class="status($v.profile.current_password)">
                    <ul class="invalid-feedback list-unstyled" v-if="$v.profile.current_password.$error">
                        <li v-if="!$v.profile.current_password.required">
                            {{'This field is required' | trans}}
                        </li>
                    </ul>
                    <form-errors :field-name="'current_password'" />
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="form-group" :class="{'form-group--error': $v.profile.password.$error}">
                    <input
                            :placeholder="'NEW PASSWORD' | trans"
                            type="password"
                            v-model="profile.password"
                            class="form-control"
                            id="password"
                            :class="status($v.profile.password)">
                    <ul class="invalid-feedback list-unstyled" v-if="$v.profile.password.$error">
                        <li v-if="!$v.profile.password.required">
                            {{'This field is required' | trans}}
                        </li>
                        <li v-if="!$v.profile.password.minLength">
                            {{'Password length must be at least 6 characters' | trans}}
                        </li>
                    </ul>
                    <form-errors :field-name="'password'" />
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="form-group" :class="{'form-group--error': $v.profile.password_confirmation.$error}">
                    <input
                            :placeholder="'CONFIRM PASSWORD' | trans"
                            type="password"
                            v-model="profile.password_confirmation"
                            class="form-control"
                            id="password_confirmation"
                            :class="status($v.profile.password_confirmation)">
                    <ul class="invalid-feedback list-unstyled" v-if="$v.profile.password_confirmation.$error">
                        <li v-if="!$v.profile.password_confirmation.required">
                            {{'This field is required' | trans}}
                        </li>
                        <li v-if="!$v.profile.password_confirmation.sameAs">
                            {{'Should be same as Password' | trans}}
                        </li>
                    </ul>
                    <form-errors :field-name="'password_confirmation'" />
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <spinner-button :className="'btn btn-danger btn-block'" @click="updatePassword" :is-pending="isPending">
                    {{'Save' | trans}}
                </spinner-button>
            </div>
        </div>
    </form>
</template>
<script>
	const { required, minLength, sameAs } = require('vuelidate/lib/validators');
	import { validationMixin } from 'vuelidate';

    export default {
	    mixins: [validationMixin],
        props: ['route'],
        data() {
            return {
                isPending: false,
                profile: {
	                current_password: "",
	                password: "",
	                password_confirmation: ""
                },
            };
        },
        methods: {
            async updatePassword() {
	            this.$v.$touch();
	            if (!this.$v.$invalid) {
		            this.isPending = true;
		            this.$store.commit(`formErrors/${this.CONSTANTS.MUTATIONS.CLEAR_ERRORS}`);
		            await axios.post(this.route, this.profile)
			            .then(() => {
                            this.EventBus.$emit('event-success', Lang.get('Success'));
				            this.$emit("passwordUpdated")
			            })
			            .finally(() => {
				            this.isPending = false;
				            this.profile.current_password = "";
				            this.profile.password = "";
				            this.profile.password_confirmation = "";
				            this.$v.$reset();
			            });
	            }
            }
        },
	    validations() {
		    let v = {
			    profile: {
				    current_password: {required},
				    password: {
				    	required,
					    minLength: minLength(6)
                    },
				    password_confirmation: {
				    	required,
					    sameAs: sameAs('password')
				    }
			    }
		    };
		    return v;
	    }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/update-password.vue